import { render } from "./Divisor.vue?vue&type=template&id=0894d498&scoped=true&ts=true"
import script from "./Divisor.vue?vue&type=script&lang=ts"
export * from "./Divisor.vue?vue&type=script&lang=ts"

import "./Divisor.vue?vue&type=style&index=0&id=0894d498&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0894d498"]])

export default __exports__